import API from '../../../../../services/api';

export const API_SERVICIOS_ENVIO = {
    newServicioEnvio: async (servicio) => {
        return API.post('/servicios-envios', servicio).then(res => res.data);
    },
    updateServicioEnvio: async (servicio) => {
        return API.put('/servicios-envios/' + servicio.id, servicio).then(res => res.data);
    },
    deleteServicioEnvio: async (idServicio) => {
        return API.delete('/servicios-envios/' + idServicio).then(res => res.data);
    }
}